import instance from 'Src/common/utilities/axios_util';
import {
  DIRECTORY_ITEM_API_PATH,
  DIRECTORY_FACET_API_PATH,
  DIRECTORY_CONFIG_API_PATH,
  GET_SPACE_PATH,
} from '../endpoints';

export const fetchItems = (directoryId, page, payload, { jwtToken, csrfToken }, sortBy) => {
  let path = DIRECTORY_ITEM_API_PATH.replace(':directoryId', directoryId).concat('?page=').concat(page);
  // Exclude Recency from ordering
  if (sortBy && sortBy !== '0' && sortBy !== '-0') path = path.concat(`&ordering=${sortBy}`);
  return instance.post(path, payload, { jwtToken, csrfToken, baseURL: '/api/v2/' });
};

export const fetchDirectoryItem = (directoryId, itemId) =>
  instance.get(DIRECTORY_ITEM_API_PATH.replace(':directoryId', directoryId).concat(itemId), {
    baseURL: '/api/v2/',
  });

export const bindActionCreator = (type, payload) => ({
  type,
  payload,
});

export const fetchFacetDirectory = (directoryId, fieldId, payload, { jwtToken, csrfToken }) =>
  instance.post(DIRECTORY_FACET_API_PATH.replace(':directoryId', directoryId).replace(':field_id', fieldId), payload, {
    jwtToken,
    csrfToken,
    baseURL: '/api/v2/',
  });

/**
 * paases the authtoken or csrk token and check if user is verified
 * @param {*} jwtToken - auth0 token
 * @param {*} csrfToken - csrf token from django session
 */
export function isUserVerified(endpoint, { jwtToken, csrfToken }) {
  return instance.get(endpoint, {
    jwtToken,
    csrfToken,
    baseURL: '/api/v2/',
  });
}

export const fetchDirectoryData = (directoryId) =>
  instance.get(DIRECTORY_CONFIG_API_PATH.replace(':directoryId', directoryId), {
    baseURL: '/api/v2/',
  });

export const verifyDirectory = (directorySlug) =>
  instance.get(DIRECTORY_CONFIG_API_PATH.replace(':directoryId', directorySlug).concat('verify/'), {
    baseURL: '/api/v2/',
  });
